module.exports = __webpack_public_path__ + "img/5.7cb5a424.jpg";